var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6484 20.8976C12.6484 22.7789 14.0922 24.2955 15.8859 24.2955H19.5464C21.1068 24.2955 22.3755 22.9684 22.3755 21.3351C22.3755 19.5559 21.6026 18.9289 20.4505 18.5205L14.5734 16.4789C13.4214 16.0705 12.6484 15.4434 12.6484 13.6643C12.6484 12.0309 13.9172 10.7039 15.4776 10.7039H19.138C20.9318 10.7039 22.3755 12.2205 22.3755 14.1018",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.75V26.25",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8763 32.0834H13.1263C5.83464 32.0834 2.91797 29.1667 2.91797 21.8751V13.1251C2.91797 5.83341 5.83464 2.91675 13.1263 2.91675H21.8763C29.168 2.91675 32.0846 5.83341 32.0846 13.1251V21.8751C32.0846 29.1667 29.168 32.0834 21.8763 32.0834Z",
    stroke: "#0B6BDD",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSquare);
export default __webpack_public_path__ + "static/media/Dollar-square.e9af27fe78fec10e6037a9dc2610e2b7.svg";
export { ForwardRef as ReactComponent };